<template>
  <v-card class="d-flex align-center justify-center" min-width="21vw" outlined style="z-index: 10!important;">
    <div style="width: 100% !important;">
      <v-card-title class="text-center py-1" >
        <v-list-item>
          <v-list-item-title><h2>{{ $t('voteFor') }} {{ feature.name }}</h2></v-list-item-title>
          <v-spacer/>
          <v-list-item-action>
            <v-icon class="icon" icon @click="closeWindow">fa-times</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-card-title>
      <v-card-text>
        <v-overlay :dark="false" :absolute="true" :value="overlayProgress"><v-progress-circular :size="70" width="5" indeterminate/></v-overlay>
        <v-container fluid>
          <v-row align="center" justify="center" class="mt-3 mr-0">
            <v-col class="d-flex align-center justify-center" @click="vote(1)" style="cursor: pointer">
              <v-icon class="icon" color="green lighten-1" x-large>fa-grin-beam</v-icon>
              <p class="mb-0 text-center ml-2" style="color: #66BB6A">{{ $t('good') }}</p>
            </v-col>
            <v-col class="d-flex align-center justify-center" @click="vote(3)" style="cursor: pointer">
              <v-icon class="icon" color="green darken-2" x-large>fa-grin-stars</v-icon>
              <p class="mb-0 text-center ml-2" style="color: #388E3C">{{ $t('great') }}</p>
            </v-col>
            <v-col class="d-flex align-center justify-center" @click="vote(3)" style="cursor: pointer">
              <v-icon class="icon" color="green darken-4" x-large>fa-grin-hearts</v-icon>
              <p class="mb-0 text-center ml-2" style="color: #1B5E20">{{ $t('perfect') }}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/analytics';
export default {
  name: "FeatureVote",
  props: {
    feature: Object,
  },
  data() {
    return {
      overlayProgress: false,
    };
  },
  methods: {
    vote(score) {
      this.overlayProgress = true;
      let voteData = {
        userId: this.$store.state.user.id,
        featureId: this.feature.id,
        score: score,
      };

      Repository.voteForFeature(voteData).then((response) => {
        if(response.status < 400) {
          alert(this.$t('alertMessage_FeatureVote'));
          this.successfulVote(voteData);
        }
      });
    },
    successfulVote(voteData) {
      this.$emit('successfulVote', voteData);
      this.closeWindow();
    },
    closeWindow() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<style scoped>

</style>


